// @ts-nocheck
import React from "react";
import { useNavigate, useParams } from "@tanstack/react-router";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import StandardDetailLayout from "@/layouts/StandardDetailLayout";
import { trpcClient } from "@/lib/trpc";
import NCRForm from "./NCRForm";
import DetailNotFoundState from "@/components/shared/DetailNotFoundState";

export default function NCREdit() {
  const navigate = useNavigate();
  const { ncrId } = useParams({ strict: false }) as { ncrId: string };
  const queryClient = useQueryClient();

  const {
    data: ncr,
    isLoading,
    error: detailError,
    refetch: refetchDetail,
  } = useQuery({
    queryKey: ["ncr", ncrId],
    queryFn: () => (trpcClient as any).ncr.getById.query({ id: ncrId }),
  });

  const handleSubmit = async (data: any) => {
    try {
      await (trpcClient as any).ncr.update.mutate({ id: ncrId, data });
      toast.success("Cập nhật biên bản NCR 8D thành công!");
      await queryClient.invalidateQueries({ queryKey: ["ncr", ncrId] });
      await queryClient.invalidateQueries({ queryKey: ["ncrs"] });
      await queryClient.invalidateQueries({ queryKey: ["ncr-all"] });
      navigate({
        to: "/ncr/$ncrId",
        params: { ncrId },
        replace: true,
      });
    } catch (err: any) {
      toast.error(err?.message || "Lỗi khi cập nhật NCR");
      throw err;
    }
  };

  if (!isLoading && !ncr) {
    return (
      <DetailNotFoundState
        breadcrumbs={[{ label: "NCR", to: "/ncr" }]}
        entityLabel="Phiếu NCR"
        backTo="/ncr"
        codeOrId={ncrId}
        error={detailError}
        onRetry={() => refetchDetail()}
      />
    );
  }
  if (isLoading || !ncr) {
    return (
      <div className="flex items-center justify-center h-48">
        <Loader2 className="h-8 w-8 animate-spin text-indigo-500" />
      </div>
    );
  }

  return (
    <StandardDetailLayout
      breadcrumbs={[
        { label: "Phiếu Không Phù Hợp (NCR)", to: "/ncr" },
        { label: (ncr as any).ncrId || ncrId, to: `/ncr/${ncrId}` },
        { label: "Chỉnh sửa & CAPA" },
      ]}
      title={`Sửa ${(ncr as any).ncrId || ""}`}
      onBack={() => navigate({ to: "/ncr/$ncrId", params: { ncrId } })}
      actions={
        <div className="flex items-center gap-2">
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => navigate({ to: "/ncr/$ncrId", params: { ncrId } })}
          >
            Hủy
          </Button>
          <Button
            type="submit"
            size="sm"
            className="bg-rose-600 hover:bg-rose-700 text-white font-bold"
            onClick={() => {
              const formEl = document.getElementById(
                "ncr-canonical-form"
              ) as HTMLFormElement | null;
              formEl?.requestSubmit();
            }}
          >
            <Save className="w-4 h-4 mr-1.5" /> Lưu Thay Đổi
          </Button>
        </div>
      }
    >
      <NCRForm
        defaultValues={ncr as any}
        onSubmit={handleSubmit}
        onCancel={() => navigate({ to: "/ncr/$ncrId", params: { ncrId } })}
        submitLabel="Lưu Thay Đổi"
      />
    </StandardDetailLayout>
  );
}
